import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface LanguageSelectorDialogState {
  isOpen: boolean;
  isForced: boolean;
}

const initialState: LanguageSelectorDialogState = {
  isOpen: false,
  isForced: false,
};

export const languageSelectorDialogSlice = createSlice({
  name: "languageSelectorDialog",
  initialState,
  selectors: {
    selectIsLanguageSelectorDialogOpen: (state) => state.isOpen,
    selectIsLanguageSelectorDialogForced: (state) => state.isForced,
  },
  reducers: {
    setIsLanguageSelectorDialogOpen: (
      state,
      action: PayloadAction<{ isOpen: boolean; isForced?: boolean }>
    ) => {
      state.isOpen = action.payload.isOpen;
      state.isForced = !!action.payload.isForced;
    },
  },
});

export const { setIsLanguageSelectorDialogOpen } =
  languageSelectorDialogSlice.actions;

export const {
  selectIsLanguageSelectorDialogOpen,
  selectIsLanguageSelectorDialogForced,
} = languageSelectorDialogSlice.selectors;

export default languageSelectorDialogSlice.reducer;
